/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-09 10:23:03
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-11 10:08:58
 * @FilePath: \goodmanger\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import HomePage from '../views/HomePage.vue'
import GoodsManagement from '../views/GoodsManagement.vue'
import OrderManagement from '../views/OrderManagement.vue'
import InfoStatistics from '../views/InfoStatistics.vue'
import GoodsTypeManagement from '../views/GoodsTypeManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/HomePage',
    name: 'HomePage',
    component: HomePage,
    children: [
      {
        path: '/goods-management',
        name: 'GoodsManagement',
        component: GoodsManagement
      },
      {
        path: '/order-management',
        name: 'OrderManagement',
        component: OrderManagement
      },
      {
        path: '/info-statistics',
        name: 'InfoStatistics',
        component: InfoStatistics
      },
      {
        path: '/goods-type-management',
        name: 'GoodsTypeManagement',
        component: GoodsTypeManagement
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
